import { Dialog, DialogActions, DialogTitle } from "@mui/material";
import React, { useRef, useState } from "react";
import NotificationAlert from "react-notification-alert";
import classes from "../../assets/css/ClientDeleteForm.module.css";
import { AxiosAPiPost } from "AxiosAPi";
import { useHistory } from "react-router-dom";
function ClientDeleteForm({
  onAlertShow,
  getAllClientList,
  deletedId,
  onCloseClientDeleteDialog,
  isOpenDelete,
}) {
  // Use to redirect to client list page after form submission //
  const history = useHistory();
  // Use to redirect to client list page after form submission //
  // Show notification popup //
  const notificationAlertRef = useRef(null);
  // Show notification popup //
  // Loading state //
  const [loadingDelete, setLoadingDelete] = useState(false);
  // Loading state //
  // Function for close dialog //
  const handleClose = () => {
    onCloseClientDeleteDialog();
  };
  // Function for close dialog //
  // Function for form submission of delete client //
  const handleDeleteClient = async () => {
    const id = {
      id: deletedId,
    };
    setLoadingDelete(true);
    AxiosAPiPost(
      `${process.env.REACT_APP_AXIOS_BASE_URL}/clients/delete`,
      "post",
      id,
      (res) => {
        if (res.data.status === true) {
          setLoadingDelete(false);
          onCloseClientDeleteDialog();
          getAllClientList();
          onAlertShow(res.data.message, "success");
        }
      },
      history,
      (err) => {
        if (err.response.data.message === "Invalid Token") {
          localStorage.clear();
          history.push("/login");
        }
        onAlertShow(err.response.data.errors[0].msg, "warning");
        setLoadingDelete(false);
      }
    );
  };
  // Function for form submission of delete client //
  return (
    <div>
      <Dialog
        open={isOpenDelete}
        onClose={handleClose}
        PaperProps={{
          style: {
            backgroundColor: "#fadf9e",
          },
        }}
      >
        <div className="rna-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to delete this client?
        </DialogTitle>
        <DialogActions>
          <button
            onClick={handleDeleteClient}
            className={classes["btn_success"]}
            type="button"
            disabled={loadingDelete}
          >
            {loadingDelete ? "Processing..." : "Yes"}
          </button>
          <button
            className={classes["btn_error"]}
            type="button"
            onClick={handleClose}
          >
            No
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ClientDeleteForm;
